import { ProductQualityMetric } from "../../types/api";
import { ProductScore } from "../../store/score/getProductScore";
import React from "react";
import ProductQualityImprovement from "./ProductQualityImprovement";
import { ShoppingCart } from "lucide-react";
import { useTranslation } from "../../i18n/hooks";

type ProductInfoProps = {
    product: ProductQualityMetric,
    productScore: ProductScore
  }
  const ProductInfo = ({product, productScore} : ProductInfoProps): React.JSX.Element => {
    const { t } = useTranslation();
    const featuredImage =
      product.featured_image || product.images_objects?.[0]?.image_url;
    const altText = product.featured_image
      ? t('productsView.product')
      : product.images_objects?.[0]?.alt_text;
    return (     <div className="flex items-start space-x-4 min-w-0">
      <div className="h-16 w-16 flex-shrink-0 bg-gray-100 rounded-lg">
        {featuredImage && (
          <div className="relative w-full h-full">
            <img
              src={featuredImage}
              alt={altText}
              className="w-full h-full object-cover rounded-lg"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
                const fallback =
                  e.currentTarget.parentElement?.querySelector(
                    ".fallback-icon"
                  );
                if (fallback) fallback.classList.remove("hidden");
              }}
            />
            <div className="fallback-icon hidden w-full h-full flex items-center justify-center bg-gray-100 rounded-lg">
              <ShoppingCart className="w-6 h-6 text-gray-400" />
            </div>
          </div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="font-medium text-lg text-gray-900 truncate">
          {product.title}
        </h2>
        <ProductQualityImprovement productScore={productScore} />
      </div>
    </div>)
  }

  export default ProductInfo